import { styled } from 'baseui'

export const CONTACTS_FILTERS_CONTROL_HEIGHT = '2.3rem'

export const Stack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
})

export const FiltersRow = styled('div', {
  display: 'grid',
  gridTemplateColumns:
    'minmax(18.75rem, 32.5rem) 13.75rem max-content max-content',
  gap: '0.75rem',
  alignItems: 'center',
  width: '100%',
})

export const SearchInputWrap = styled('div', {
  width: '100%',
})

export const CountrySelectWrap = styled('div', {
  width: '13.75rem',
})

export const OnlyWithContractsWrap = styled('div', {
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
})

export const SearchButtonWrap = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
})

export const ContactsSearchInputOverrides = {
  Root: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
    },
  },
  InputContainer: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
      minHeight: CONTACTS_FILTERS_CONTROL_HEIGHT,
      alignItems: 'center',
    },
  },
  Input: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
    },
  },
}

export const ContactsCountrySelectOverrides = {
  ControlContainer: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
      minHeight: CONTACTS_FILTERS_CONTROL_HEIGHT,
      alignItems: 'center',
    },
  },
  ValueContainer: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  SingleValue: {
    style: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  Placeholder: {
    style: {
      display: 'flex',
      alignItems: 'center',
    },
  },
}

export const ContactsSearchButtonOverrides = {
  BaseButton: {
    style: {
      height: CONTACTS_FILTERS_CONTROL_HEIGHT,
      minHeight: CONTACTS_FILTERS_CONTROL_HEIGHT,
    },
  },
}

export const ToggleButtonOverrides = {
  BaseButton: {
    style: () => ({
      borderRadius: '0.6rem',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem',
      whiteSpace: 'nowrap',
    }),
  },
}

export const CountryOptionRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  paddingTop: 0,
  paddingBottom: 0,
})

export const CountryOptionIcon = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.5rem',
  height: '1.5rem',
  flex: '0 0 auto',
})

export const CountryLabel = styled('span', {
  fontSize: '1rem',
  color: '#111827',
  whiteSpace: 'nowrap',
})

export const StatusCell = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
})

export const StatusDot = styled('span', {
  display: 'inline-block',
  width: '0.625rem',
  height: '0.625rem',
  borderRadius: '999px',
})

export const StatusDotSuccess = styled(StatusDot, {
  backgroundColor: '#16A34A',
})

export const StatusDotWarning = styled(StatusDot, {
  backgroundColor: '#D97706',
})

export const StatusDotDanger = styled(StatusDot, {
  backgroundColor: '#DC2626',
})

export const StatusDotAccent = styled(StatusDot, {
  backgroundColor: '#2563EB',
})

export const StatusDotNeutral = styled(StatusDot, {
  backgroundColor: '#9CA3AF',
})
